import React from 'react';
import PropTypes from 'prop-types';
import ValidatingForm from '../forms/validating_form';
import TextField from '../fields/text_field';

class Name extends ValidatingForm {
  requiredFieldNames() {
    return [
      'first_name',
      'last_name',
    ];
  }
  componentDidUpdate(prevProps, prevState){
    if(JSON.stringify(this.state.erroredFields) !== JSON.stringify(prevState.erroredFields)){
      this.props.updateFormError(this._reactInternalFiber.type.name.toLowerCase(), this.state.erroredFields)
    }
  }
  render() {
    return (
      <div>
        <div className='input-error'>{ this.state.errorMessage }</div>

        <form className='ordination-form'>
          <label>
            <h3 className='form-section-title'>Your Legal Name</h3>
            <div className='l-row'>
              <TextField
                required
                name='first_name'
                displayName='First'
                onChange={ this.props.updateFormError }
                updateModel={ this.props.updateModel }
                updateErrorMessage={ this.updateErrorMessage }
                value={ this.props.minister.first_name }
                onError={ this.addError }
                onValid={ this.removeError }
                className='l-columns-600-4'/>
              <TextField
                name='middle_name'
                displayName='Middle'
                updateModel={ this.props.updateModel }
                updateErrorMessage={ this.updateErrorMessage }
                value={ this.props.minister.middle_name }
                onError={ this.addError}
                onValid={ this.removeError }
                className='l-columns-600-4'/>
              <TextField
                required
                name='last_name'
                displayName='Last'
                updateModel={ this.props.updateModel }
                updateErrorMessage={ this.updateErrorMessage }
                value={ this.props.minister.last_name }
                onError={ this.addError }
                onValid={ this.removeError }
                className='l-columns-600-4'/>
            </div>
          </label>
        </form>
      </div>
    );
  }
}

Name.propTypes = {
  minister: PropTypes.object.isRequired,
  updateModel: PropTypes.func.isRequired,
};

export default Name;
